import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { CaretDown } from "@phosphor-icons/react";

/**
 * A rounded filter pill with a dropdown, in the style of the Insights filters (`FootPrint.jsx`'s
 * `YearDropdown` / `QuarterDropdown`): small, pill-shaped, grey outline, a caret, the current choice as its
 * label. Local to Foundation Data v2 rather than imported from Insights — those take Insights-specific props
 * (a fixed year range, quarters) that this page does not have.
 *
 * `options` is `[{ value, label }]`; `value` is the selected option's value (null for none).
 */
export default function FilterPill({ value, options, onChange, placeholder, ariaLabel }) {
  const selected = options.find((option) => option.value === value);
  return (
    <Menu>
      <MenuButton
        as={Button}
        size="sm"
        borderRadius="full"
        border="1px solid"
        borderColor="gray.300"
        bg="transparent"
        color="gray.600"
        fontWeight="normal"
        rightIcon={<CaretDown size={14} />}
        _hover={{ bg: "gray.50", borderColor: "gray.400" }}
        _active={{ bg: "gray.50" }}
        aria-label={ariaLabel}
      >
        {selected?.label ?? placeholder}
      </MenuButton>
      <MenuList borderRadius="lg" border="1px solid" borderColor="gray.200" boxShadow="md" py={1} maxH="320px" overflowY="auto">
        {options.map((option) => (
          <MenuItem
            key={String(option.value)}
            onClick={() => onChange(option.value)}
            fontWeight={option.value === value ? "bold" : "normal"}
          >
            {option.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
